@if (caseCtx.activeCase()) {
  <!-- Zero-height anchor — the active-case pill UI lives in the topbar
       now (see app-topbar). This empty .case-bar host keeps the picker
       dropdown's `position: absolute; top: 100%` math anchored just
       below the topbar/case-bar handoff line. -->
  <div class="case-bar case-bar--anchor" aria-hidden="true"></div>
} @else {
  <div class="case-bar case-bar--empty">
    <span><strong>No case scenario active</strong> · viewing all products available to your shelf</span>
    <button class="case-bar-cta" type="button" (click)="newCase()">+ New case scenario</button>
  </div>
}

@if (caseCtx.pendingDiff(); as d) {
  <div class="diff-banner">
    <span class="diff-text">
      Since you last viewed: <strong>{{ d.newIds.length }} new fit{{ d.newIds.length === 1 ? '' : 's' }}</strong>
      @if (d.droppedIds.length > 0) {
        · <strong>{{ d.droppedIds.length }} dropped</strong>
      }
    </span>
    <button class="diff-x" type="button" (click)="caseCtx.dismissDiff()" aria-label="Dismiss">×</button>
  </div>
}

@if (pickerOpen()) {
  <div class="case-picker" (click)="$event.stopPropagation()">
    <div class="dd-section-label">Recent scenarios</div>
    @for (c of recent(); track c.id) {
      <div class="dd-item" [class.active]="caseCtx.activeCase()?.id === c.id" (click)="selectCase(c)">
        <span class="dd-name">{{ c.name }}</span>
        <span class="dd-meta">{{ c.age }} · {{ c.state }} · ${{ (c.premium ?? 0) / 1000 | number:'1.0-0' }}K</span>
      </div>
    }
    @if (recent().length === 0) {
      <div class="dd-empty">No case scenarios yet.</div>
    }
    <div class="dd-divider"></div>
    <button class="dd-action" type="button" (click)="newCase()">+ New case scenario</button>
    @if (caseCtx.activeCase()) {
      <button class="dd-action dd-action--danger" type="button" (click)="clearActive()">
        Clear active scenario (work without one)
      </button>
    }
  </div>
}
